import { render, staticRenderFns } from "./OuterBlock.vue?vue&type=template&id=40699610&"
import script from "./OuterBlock.vue?vue&type=script&lang=js&"
export * from "./OuterBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports